<template>
  <v-app>
    <header role="banner" class="sr-header" aria-label="Site header"></header>
    <v-main tag="main" role="main">
      <router-view></router-view>
    </v-main>
    <footer role="contentinfo" class="sr-footer" aria-label="Site footer"></footer>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      isLoading: false,
    };
  },
  created() {},
  beforeDestroy() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.sr-header,
.sr-footer {
  display: none;
}
</style>
